import { useWizard } from "react-use-wizard";
import { toReadablePrice } from "../../../../../../../lib/utils";
import RangeByRegionByFacilityTypeStep from "../../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";
import buySteps from "../buySteps";
interface IWishStep_3 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const WishStep_3 = ({ typeIds, selectedPolygonIds }: IWishStep_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_2);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_6);
  };

  const handleRepeatStep = () => {
    goToStep(buySteps.wishesSteps.step_4);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        typeIds={typeIds ?? []}
        selectedPolygonIds={selectedPolygonIds ?? []}
        onNextStep={handleNextStep}
        onRepeatStep={typeIds?.length === 1 ? handleRepeatStep : undefined}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default WishStep_3;
